import type { CSSProperties } from 'react';

// Root ErrorBoundary fallback (Sentry LUTIQ-74). It renders when the app has
// already crashed, so it must be fully self-contained: no MUI, no
// ThemeProvider, no router — plain elements with inline styles only. Colors
// and type mirror theme.ts (Indigo on the warm Paper workspace) as literals.
const styles: Record<'root' | 'card' | 'title' | 'body' | 'button', CSSProperties> = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 24,
    fontFamily: '"Supreme", -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    backgroundColor: '#FAF8F3',
  },
  card: {
    width: '100%',
    maxWidth: 400,
    padding: '32px 28px',
    borderRadius: 8,
    border: '1px solid #E4E0D5',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 8px 24px rgba(25, 28, 51, 0.06)',
    textAlign: 'center',
  },
  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: '#191C33',
  },
  body: {
    margin: '10px 0 24px',
    fontSize: 14,
    lineHeight: 1.6,
    color: '#565A6E',
  },
  button: {
    padding: '10px 24px',
    borderRadius: 8,
    border: 'none',
    backgroundColor: '#4F46E5',
    color: '#FFFFFF',
    fontFamily: 'inherit',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.02em',
    cursor: 'pointer',
  },
};

const CrashFallback = () => (
  <div style={styles.root}>
    <div style={styles.card} role="alert">
      <h1 style={styles.title}>Something went wrong</h1>
      <p style={styles.body}>An unexpected error kept this page from loading.</p>
      <button type="button" style={styles.button} onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  </div>
);

export default CrashFallback;
